import config from "../../config";
const baseUrl = config.baseUrl;

export const BlogUrls = {

  BLOG_ADD: baseUrl + "/blog",
  BLOG_EDIT: baseUrl + "/blog",
  BLOG_LIST: baseUrl + "/blog",
  BLOG_DELETE: baseUrl + "/blog",
  BLOG_GETBYID: baseUrl + "/blog",
  BLOG_DROPDOWN: baseUrl + "/blog/dropdown?export=true",
  BLOG_ROLLBACK: baseUrl + "/blog/rollback",
  BlOG_DELETE_HARD:baseUrl + "/blog",

};
